export default __webpack_public_path__ + "static/media/169.897b7851.svg";